import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BreakPointsMFirst } from '~/src/constants/breakpoints';

const InputPhoneDecorator = phoneDecorator(InputSimple);
const InputNameDecorator = nameDecorator(InputSimple);

const CommonInputCss = css`
    width: 277px;

    @media (max-width: ${breakPoints.mobile}) {
        width: 254px;
        margin-bottom: 0;
    }
`;

export const InputPhone = styled(InputPhoneDecorator)`
    ${CommonInputCss};

    @media (min-width: ${BreakPointsMFirst.mobile}) and (max-width: ${breakPoints.tablet}) {
        margin-left: 14px;
    }
`;

export const InputName = styled(InputNameDecorator)`
    ${CommonInputCss};
`;

export const ThrobberGlobal = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 3;
`;

export const CallbackButton = styled(BaseButton)`
    width: 289px;
    ${FONTS.S};
`;

export const DoubleButtonComponent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
`;

export const AgreeTextWrap = styled.div`
    cursor: default;
    ${FONTS.XXS};
    align-items: center;

    @media (max-width: ${breakPoints.mobile}) {
        font-size: 10px;
    }
`;

export const AgreeTextUnderLine = styled.a`
    ${FONTS.MediumXXS};
    color: ${COLORS.Link};
`;
